
import React from 'react';
import CenteredText from '../common/CenteredText'
import LoggedInBoundry from '../common/LoggedInBoundry';


const Dashboard = () => {
  document.title = 'Cloudjob agency | Dashboard 🎛️';
  return (
    <LoggedInBoundry>
      <CenteredText variant='h3'>
        Dashboard is under maintanence
      </CenteredText>
    </LoggedInBoundry>
  );
};

export default Dashboard;
